import type { AsMutableArray, MutableOrImmutableArray } from "../array-checks.js";


type UniqueTupleValuesHelper<A extends MutableOrImmutableArray<any>, Result extends MutableOrImmutableArray<any>> =
  AsMutableArray<A> extends [ infer FirstPart, ...infer Remaining ]
  ? (
    A extends Readonly<any>
    ? (FirstPart extends Result[ number ] ? UniqueTupleValuesHelper<readonly [ ...Remaining ], readonly [ ...Result ]> : UniqueTupleValuesHelper<readonly [ ...Remaining ], readonly [ ...Result, FirstPart ]>)
    : (FirstPart extends Result[ number ] ? UniqueTupleValuesHelper<Remaining, Result> : UniqueTupleValuesHelper<Remaining, [ ...Result, FirstPart ]>)
  )
  : Result;

export type UniqueTupleValues<A extends MutableOrImmutableArray<any>>
  = AsMutableArray<A> extends [ infer FirstPart, ...infer Remaining ]
  ? (
    A extends Readonly<any>
    ? UniqueTupleValuesHelper<readonly [ ...Remaining ], readonly [ FirstPart ]>
    : UniqueTupleValuesHelper<Remaining, [ FirstPart ]>
  )
  : [];


export function uniqueTupleValues<A extends MutableOrImmutableArray<any>> (array: A): UniqueTupleValues<A> {
  return array.filter((v, i) => {
    return i === array.indexOf(v);
  }) as UniqueTupleValues<A>;
}